<template>
  <div class="strategy_wrap">
    <navbar_ :Lucency="false" :isBlack="true" :activeIndex="''" />
  </div>
</template>

<script>
import navbar_ from "@/components/navbar/index.vue"; // 顶部导航
import footer_ from "@/components/footer/index.vue"; // 底部

export default {
  components: {
    navbar_,
    footer_,
  },
  data() {
    return {};
  },
};
</script>